// extracted by mini-css-extract-plugin
export var container = "_ch-0";
export var popoverContent = "_ch-1";
export var tosLink = "_ch-2";